import { call, put, takeEvery } from "redux-saga/effects";
import { keHoachKyApi } from "../../../api/ke-hoach/keHoachKyApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IKeHoachKy } from "../../../model/respone/ke-hoach/IKeHoachKy";
import { eKeHoachKyActionIds, IKeHoachKyActionTypes } from "../../action-types/ke-hoach/IKeHoachKyActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.keHoach.keHoachKy;

export function* keHoachKySaga(): any {
    yield takeEvery(eKeHoachKyActionIds.LOAD_START, loadWorker);
    yield takeEvery(eKeHoachKyActionIds.SAVE_START, saveWorker)
    yield takeEvery(eKeHoachKyActionIds.UPDATE_LOCK_STATUS_START, updateLockStatusWorker)
    yield takeEvery(eKeHoachKyActionIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: IKeHoachKyActionTypes): any {
    const res: IBaseRespone = yield call(keHoachKyApi.SelectByNamHoc, action.payload as string);
    if (res.is_success) {
        yield put(rootActions.keHoach.keHoachKy.LOAD_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.keHoach.keHoachKy.LOAD_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* saveWorker(action: IKeHoachKyActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IKeHoachKy
  if (payload.id > 0) {
    res = yield call(keHoachKyApi.Update, payload)
  } else {
    res = yield call(keHoachKyApi.Insert, payload)
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data))
  } else {
    yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
  }
}

function* updateLockStatusWorker(action: IKeHoachKyActionTypes): any {
  const payload = action.payload as IKeHoachKy
  const res: IBaseRespone = yield call(keHoachKyApi.UpdateLockStatus, payload)
  if (res.is_success) {
    yield put(mainAction.UPDATE_LOCK_STATUS_SUCCESS(res.data))
  } else {
    yield put(mainAction.UPDATE_LOCK_STATUS_ERROR(res.message ?? "Có lỗi"))
  }
}

function* deleteWorker(action: IKeHoachKyActionTypes): any {
  const res: IBaseRespone = yield call(keHoachKyApi.Delete, action.payload as number)
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data))
  } else {
    yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
  }
}
